import React from 'react';

import { InvoiceAlert } from 'utils/invoiceAlert';

import { Pill } from './invoice-alert-pill.styles';

/**
 * Aviso de fatura na superfície do card da UC ("Fatura em aberto" / "Vence em Nd").
 * Componente compartilhado pelos cards do dashboard e da lista de UCs para o
 * aviso não divergir; a regra (e a fonte do dado) vive em `utils/invoiceAlert`.
 */
export const InvoiceAlertPill = ({ alert }: { alert: InvoiceAlert }) => (
  <Pill $kind={alert.kind}>{alert.label}</Pill>
);
